/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Passenger_CapacityInputs */

const en_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passenger Seating`)
};

const es_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asientos para pasajeros`)
};

const fr_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de passagers`)
};

const de_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passagiersitzplätze`)
};

const ja_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乗客定員`)
};

const zh_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乘客座位数`)
};

const ar_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعة الركاب`)
};

const id_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas Penumpang`)
};

const it_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posti Passeggeri`)
};

const ru_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пассажировместимость`)
};

const pt_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade de Passageiros`)
};

const ko_field_passenger_capacity = /** @type {(inputs: Field_Passenger_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여객 좌석 수`)
};

/**
* | output |
* | --- |
* | "Passenger Seating" |
*
* @param {Field_Passenger_CapacityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_passenger_capacity = /** @type {((inputs?: Field_Passenger_CapacityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Passenger_CapacityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_passenger_capacity(inputs)
	if (locale === "es") return es_field_passenger_capacity(inputs)
	if (locale === "fr") return fr_field_passenger_capacity(inputs)
	if (locale === "de") return de_field_passenger_capacity(inputs)
	if (locale === "ja") return ja_field_passenger_capacity(inputs)
	if (locale === "zh") return zh_field_passenger_capacity(inputs)
	if (locale === "ar") return ar_field_passenger_capacity(inputs)
	if (locale === "id") return id_field_passenger_capacity(inputs)
	if (locale === "it") return it_field_passenger_capacity(inputs)
	if (locale === "ru") return ru_field_passenger_capacity(inputs)
	if (locale === "pt") return pt_field_passenger_capacity(inputs)
	return ko_field_passenger_capacity(inputs)
});